// extracted by mini-css-extract-plugin
export default {"notesBox":"_022dFFzatl_B_t5gezM"};